import { CompaniesService } from '@/lib/api/services/companies'
import { useAsyncData } from '@/hooks/useAsyncData'
import type { RoleModelFinderBannerVisibilityResponse } from '@/lib/api/types/api'

export function useRoleModelBannerVisibility(openUrl: string): boolean {
  const { data: data } = useAsyncData<RoleModelFinderBannerVisibilityResponse>(async () => {
    if (!openUrl) {
      throw new Error('openUrl is required')
    }
    const res = await CompaniesService.getRoleModelFinderBannerVisibility(openUrl)
    return res
  }, [openUrl])

  return data?.visible ?? false
}
